import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['../header/header.component.css']
})
export class PublicHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
